import { useToast } from '@chakra-ui/react';
import { Toast } from '@diamond/shared/ui';
import { useEffect } from 'react';

export function usePwaUpdateNotification(isEnabled: boolean) {
  const toast = useToast();

  useEffect(() => {
    if (!isEnabled || !('serviceWorker' in navigator)) return;

    const serviceWorker = navigator.serviceWorker;
    let hadServiceWorkerController = Boolean(serviceWorker.controller);

    const handleControllerChange = () => {
      if (!hadServiceWorkerController) {
        hadServiceWorkerController = true;
        return;
      }

      if (toast.isActive('pwa-update-available')) return;

      toast({
        id: 'pwa-update-available',
        status: 'warning',
        duration: null,
        isClosable: true,
        render: ({ onClose }) => (
          <Toast
            id="pwa-update-available"
            status="warning"
            description="Versi baru tersedia."
            isClosable
            onClose={onClose}
            action={{
              label: 'Muat ulang',
              onClick: () => window.location.reload(),
            }}
          />
        ),
      });
    };

    serviceWorker.addEventListener('controllerchange', handleControllerChange);
    return () => {
      serviceWorker.removeEventListener(
        'controllerchange',
        handleControllerChange
      );
    };
  }, [isEnabled, toast]);
}
